<template>
    <el-row v-loading="loading">
        <el-col :span="12">
            <el-table 
            v-if="!loading"
            :data="count_data" 
            border 
            height="300"
            show-summary
            :header-cell-style="{background: '#f3faff'}"
            >
                <el-table-column prop="name" label="班级数"></el-table-column>
                <el-table-column prop="count_num" label="总客户数"></el-table-column>
                <el-table-column prop="formal_customer_num" label="成交客户数"></el-table-column>
                <el-table-column prop="formal_order_num" label="正式订单数"></el-table-column>
                <el-table-column prop="pfm_amount" label="新增业绩"></el-table-column>
                <el-table-column prop="renew_amount" label="续费业绩"></el-table-column>
            </el-table>
        </el-col>
        <el-col :span="12">
            <div ref="customerSize" :style="{ height: map_height, width: '100%' }"></div>
        </el-col>
    </el-row>
</template>
  
<script>
import CustomerCount from "~/services/CustomerCount";
import echarts from "echarts";

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        map_height:{
            type: String,
            default: '500px',
        }
    },
    data() {
        return {
            loading: false,
            count_data: null,
        };
    },
    created(){
        this.getData(this.params);
    },
    mounted() {
        
    },
    methods: {
        getData(params) {
            this.loading = true;
            CustomerCount.getCount(params, 'size-list').then((res) => {
                this.loading = false;
                if (res.code == 0 && res.data && res.data.length > 0) {
                    //初始化地图
                    this.count_data = res.data;
                    this.initChart();
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
        initChart() {
            if (!this.count_data || this.count_data.length < 4) {
                return false;
            }

            // 定义列标题
            const titles = ['customer', 'count_num', 'formal_customer_num', 'formal_order_num', 'pfm_amount', 'renew_amount'].filter((field, index) => {
                if(field == 'customer'){
                    return true;
                }
                return !this.count_data.every(item => item[field] == 0); // 如果不是全部为0，保留该字段
            });
            // 使用map函数将每个对象转换成一个数组
            const dataRows = this.count_data.map(item => [
                item.name,
                item.count_num,
                item.formal_customer_num,
                item.formal_order_num,
                item.pfm_amount,
                item.renew_amount
            ]);

            // 合并标题行和数据行来创建最终的二维数组
            const source = [titles, ...dataRows];

            const chartContainer = this.$refs.customerSize;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer);
            const option = {
                color: [
                    "#5470c6",
                    "#91cc75",
                    "#fac858",
                    "#ee6666",
                    "#73c0de",
                    "#3dac78",
                ],
                legend: {},
                tooltip: {},
                dataset: {
                    source: source
                },
                series: [
                    {
                        name: '总客户数',
                        type: 'pie',
                        radius: '40%',
                        center: ['25%', '30%'],
                        encode: {
                            itemName: 'customer',
                            value: 'count_num'
                        }
                    // No encode specified, by default, it is '2012'.
                    },
                    {
                        name: '成交客户数',
                        type: 'pie',
                        radius: '30%',
                        center: ['75%', '30%'],
                        encode: {
                            itemName: 'customer',
                            value: 'formal_customer_num'
                        }
                    },
                    {
                        name: '正式订单数',
                        type: 'pie',
                        radius: '30%',
                        center: ['20%', '75%'],
                        encode: {
                            itemName: 'customer',
                            value: 'formal_order_num'
                        }
                    },
                    {
                        name: '新增业绩',
                        type: 'pie',
                        radius: '30%',
                        center: ['50%', '75%'],
                        encode: {
                            itemName: 'customer',
                            value: 'pfm_amount'
                        }
                    },
                    {
                        name: '续费业绩',
                        type: 'pie',
                        radius: '30%',
                        center: ['80%', '75%'],
                        encode: {
                            itemName: 'customer',
                            value: 'renew_amount'
                        }
                    }
                    ]
                };
            myChart.setOption(option);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('合计：');
                return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                // 确保当前项没有子级数据，即它是顶级行
                if (!item.children) {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                }
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                sums.push('--');
                }
            });
            return sums;
        }
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/table/customerSize.vue